<template>
  <div class="content-video">
    <iframe
    ref="videoRef"
    :src="url"
    class="responsive-iframe"
    frameborder="0"
    allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
  props:{
    url: {
      default: ''
    },
    type:{
      default:''
    }

  },
  mounted(){
    setTimeout(() => {
        this.iframeVideo()
    }, 1000);
  },
  methods: {
    iframeVideo() {
      let vimeo = new Player(this.$refs.videoRef); 
      const selt = this
      vimeo.on('timeupdate', function(data) {
          selt.$emit('timeVideo', Number(data.seconds))
      });

      vimeo.on('progress', function(data) {
        if(data.percent > 0.9 && (selt.type === 1 || selt.type === 2))
          selt.$emit('userResourse')
      });

      
    }
  },
};
</script>

<style scoped>
.vimeoPlayer {
  height: 100%;
  width: 100%;
}
.content-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; 
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

</style>
